'use client';

import { c as _c } from "react/compiler-runtime";
import { ApyCardsPerformanceLoading } from '../PerformanceDataList/ApyDataList';
import { VaultFeesLoading } from '../PerformanceDataList/VaultFees';
import PerformanceSectionLayout from '../VaultPerformanceLayout';

/** Mirrors `PerformanceDataListClient`: returns, then fees. */
const VaultPerformanceLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PerformanceSectionLayout><ApyCardsPerformanceLoading /></PerformanceSectionLayout><VaultFeesLoading /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VaultPerformanceLoading;